import React, { useState } from 'react';
import {
  EyeIcon,
  BookmarkIcon,
  ArrowUpTrayIcon,
} from '@heroicons/react/24/outline';
import { BookmarkIcon as BookmarkIconSolid } from '@heroicons/react/20/solid';
import { EyeIcon as EyeIconSolid } from '@heroicons/react/20/solid';
import ShareShowModal from './ShareShowModal';

/**
 * Seen, save, and share actions for a show (feed cards, show detail page, etc.).
 */
function ShowActionButtons({
  showId,
  showTitle,
  isSeen,
  isSaved,
  onSeenClick,
  onSaveClick,
}) {
  const [shareOpen, setShareOpen] = useState(false);

  return (
    <>
      <div className="flex-none flex items-center gap-2">
        <button
          type="button"
          className="cursor-pointer p-0 border-0 bg-transparent"
          aria-label={isSeen ? 'Mark as not seen' : 'Mark as seen'}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            onSeenClick();
          }}
        >
          {isSeen ? (
            <EyeIconSolid className="w-6 text-black" />
          ) : (
            <EyeIcon className="w-6" />
          )}
        </button>
        <button
          type="button"
          className="cursor-pointer p-0 border-0 bg-transparent"
          aria-label="Save to list"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            onSaveClick();
          }}
        >
          {isSaved ? (
            <BookmarkIconSolid className="w-6" />
          ) : (
            <BookmarkIcon className="w-6" />
          )}
        </button>
        <button
          type="button"
          className="cursor-pointer p-0 border-0 bg-transparent"
          aria-label="Share show"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            setShareOpen(true);
          }}
        >
          <ArrowUpTrayIcon className="w-6" />
        </button>
      </div>
      <ShareShowModal
        isOpen={shareOpen}
        onClose={() => setShareOpen(false)}
        showId={showId}
        showTitle={showTitle}
      />
    </>
  );
}

export default ShowActionButtons;
